import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  demandeDetailContainer: {
    padding: 4,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
    width: '100%',    
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#6b7280',
    width: '30%',
  },
  value: {
    fontSize: 14,
    color: '#374151',
    width: '70%',   
  },
})

export default styles